exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay--active:before{opacity:1!important}[dir] .overlay--active:before{background:rgba(0,0,0,.5)!important}.dialog{overflow:hidden!important;overflow-y:auto!important}[dir] .dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important}.image-upload-icon{position:absolute;top:50%}[dir=ltr] .image-upload-icon{left:50%;transform:translate(-50%,-50%)}[dir=rtl] .image-upload-icon{right:50%;transform:translate(50%,-50%)}.image-upload{position:relative}[dir] .image-upload{border:1px dashed #ccc;cursor:pointer;background-position:50%;background-size:cover;border-radius:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ae15116a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/globalWebsite/addEditGlobalWebsite.vue
// module id = 1361
// module chunks = 0